import { SYSTEM_CATEGORIES, type SystemCategoryId } from 'markcat-domain';
import { SidebarSection } from './SidebarSection';
import styles from './SidebarNav.module.css';

interface SystemCategoriesProps {
  counts: Record<SystemCategoryId, number>;
  selectedId: SystemCategoryId | null;
  onSelect: (id: SystemCategoryId | null) => void;
}

export function SystemCategories({ counts, selectedId, onSelect }: SystemCategoriesProps) {
  // Only show categories that have bookmarks
  const visible = SYSTEM_CATEGORIES.filter((c) => counts[c.id] > 0);
  if (visible.length === 0) return null;

  return (
    <SidebarSection id="issues" title="Issues" activeLabel={visible.find(c => c.id === selectedId)?.label}>
      {visible.map((cat) => (
        <button
          key={cat.id}
          className={`${styles.row} ${styles.warning} ${selectedId === cat.id ? styles.selected : ''}`}
          aria-pressed={selectedId === cat.id}
          onClick={() => onSelect(selectedId === cat.id ? null : cat.id)}
        >
          <span className={styles.label}>{cat.label}</span>
          <span className={styles.count}>{counts[cat.id]}</span>
        </button>
      ))}
    </SidebarSection>
  );
}
